import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalDefaultProps } from 'components/Modal';
import { useMedia } from 'modules/common/hooks/useMedia';
import { ModalTemplate } from 'components/ModalTemplate';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';

import { ScCurrencyRemovalDeclined } from './styled';

export const CurrencyRemovalDeclined = forwardRef<
  HTMLDivElement,
  ModalDefaultProps
>(({ onClose }, ref) => {
  const { isMobileS } = useMedia();
  const { t } = useTranslation('deposits');
  const modalTemplateSettings: ModalTemplateSettings = useMemo(
    () =>
      isMobileS
        ? {
            type: 'mobile',
            mode: {
              type: 'default',
            },
          }
        : {
            type: 'desktop',
            size: 'xSmall',
            mode: {
              type: 'default',
            },
          },
    [isMobileS]
  );

  return (
    <ModalTemplate onClose={onClose} ref={ref} settings={modalTemplateSettings}>
      <ScCurrencyRemovalDeclined>
        <div className="title">{t('editCurrency.removalDeclined')}</div>
        <div className="text">{t('editCurrency.currencyHasBalance')}</div>
      </ScCurrencyRemovalDeclined>
    </ModalTemplate>
  );
});
